// Keep desktop filter popovers from overlapping; delegated handling survives Shopify rerenders.
(() => {
  document.addEventListener('toggle', (event) => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.matches('.facets__disclosure') || !current.open) return;
    const toolbar = current.closest('.facets__wrapper');
    if (!toolbar) return;
    toolbar.querySelectorAll('.facets__disclosure[open]').forEach((other) => {
      if (other !== current) other.open = false;
    });
  }, true);
})();
